import { IDI_CALENDAR_SEARCH_START_LOADING, IDI_CALENDAR_SEARCH_END_LOADING, IDI_CALENDAR_SEARCH_LOADED, SET_IDI_CALENDAR_FILTER } from "../constants/IdiCalendarConstants";
import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiCalendarSearch(userId, filters, navigate) {
    return async (dispatch) => {
        await dispatch({ type: IDI_CALENDAR_SEARCH_START_LOADING });
        try {
            filters.userId = userId;
            var data = await postApiJsonData("IdiInspection/GetIdiCalendarFBO", filters, null);
            if(data.success) {
                await dispatch({
                    type: IDI_CALENDAR_SEARCH_LOADED,
                    payload: data.responseEntities[0]
                });
            } else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: IDI_CALENDAR_SEARCH_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_CALENDAR_SEARCH_END_LOADING });
        }
    };
}

export function setIdiCalendarFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_CALENDAR_FILTER,
            payload: filter
        });
    };
}
